import dictionary from '../../../../data/dictionary';

const languages = Object.entries(dictionary).reduce((acc, [code, dict]) => {
    acc[code] = {
        dayNameShort: [dict.DNS_1, dict.DNS_2, dict.DNS_3, dict.DNS_4, dict.DNS_5, dict.DNS_6, dict.DNS_7],
        dayNameLong: [dict.DNL_1, dict.DNL_2, dict.DNL_3, dict.DNL_4, dict.DNL_5, dict.DNL_6, dict.DNL_7],
        monthNameShort: [
            dict.MNS_1,
            dict.MNS_2,
            dict.MNS_3,
            dict.MNS_4,
            dict.MNS_5,
            dict.MNS_6,
            dict.MNS_7,
            dict.MNS_8,
            dict.MNS_9,
            dict.MNS_10,
            dict.MNS_11,
            dict.MNS_12,
        ],
        monthNameLong: [
            dict.MNL_1,
            dict.MNL_2,
            dict.MNL_3,
            dict.MNL_4,
            dict.MNL_5,
            dict.MNL_6,
            dict.MNL_7,
            dict.MNL_8,
            dict.MNL_9,
            dict.MNL_10,
            dict.MNL_11,
            dict.MNL_12,
        ],
    };
    return acc;
}, {});

export default languages;



// WEBPACK FOOTER //
// ./src/components/shared/vue-calendar/utils/languages.js